<template>
    <div class="blue-ribbon">
        <slot />
    </div>
</template>
<script>
export default {
    name:'BlueRibbon'
}
</script>